<!--
 * @Description: 重置密码
 * @Date: 2021-11-10 13:44:01
-->
<template>
  <!-- 右侧  -->
  <div class="user-login__item user-login__success">
    <base-svg
      :iconClass="`chenggong`"
      className="user-login__success-svg"
    ></base-svg>
    <div class="user-login__success-foot">
      <p>
        密码设置成功,
        <span class="user-login__success-yellow">{{ counter }}</span>
        秒后将直接登录
      </p>
      <p>
        若无反应点击进入
        <span
          class="user-login__success-yellow user-login__success-jump"
          @click="onJump"
        >
          SaaS业务平台
        </span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BaseSvg } from '@/components/base/base-svg';
import { useInterval } from '@vueuse/core';
import { useRouter } from 'vue-router';

const router = useRouter();
const counter = ref(2);
const { pause } = useInterval(1000, {
  controls: true,
  immediate: true,
  callback: () => {
    counter.value--;
    if (counter.value <= 0) {
      pause();
      goHome();
    }
  }
});
const goHome = (): void => {
  router.replace({ path: '/' });
};

const onJump = (): void => {
  goHome();
};
</script>

<style scoped lang="scss">
.user-login__success {
  text-align: center;

  .user-login__success-svg {
    width: 86px;
    height: 86px;
    margin-top: 49px;
    margin-bottom: 24px;
  }

  .user-login__success-foot {
    font-size: 14px;
    > p {
      color: #4c4c4c;
    }
    .user-login__success-jump {
      cursor: pointer;
    }
  }
  .user-login__success-yellow {
    color: #fa8203;
  }
}
</style>
